<div class="sa-create-incident-menu-from-rc" id="toggle-menu">
  <div
    id="toggle-menu"
    class="btn btn-default btn-sm text-uppercase embed-toggle-menu"
    [sotiPopupTriggerFor]="createIncidentPopup"
    [popUpDisableClick]="embeddingDisabled"
    [class.active]="menuToggle"
    [class.btn-disabled]="embeddingDisabled"
    type="button"
    (popUpOpened)="startCreateIncident()"
    (popUpClosed)="cancel()"
    [popUpOverlayBackdrop]="false"
  >
    <div class="btn-content">
      <span class="hd-icon hd-icon-add icon-sm prefix-icon"></span>
      <span>{{ 'addToIncident_Button' | xsI18n }}</span>
    </div>
  </div>
  <soti-popup
    class="create-incident-popup"
    #createIncidentPopup="sotiPopup"
    position="centerTop"
    [noBeak]="true"
    [noFallback]="true"
  >
    <xs-popup-menu
      #saPopupMenu
      class="create-incident-dropdown"
      sa-stop-propagation
      [isOpen]="menuToggle"
      [keepOpen]="keepOpen"
      [targetSelector]="'#toggle-menu'"
      [popupAlign]="''"
      (onVisibilityChange)="setExpandedMenu($event)"
      disableDropup="true"
    >
      <div class="create-incident-form" sa-stop-propagation>
        <div *ngIf="menuToggle" class="menu-beak"></div>
        <div class="new-incident-outer">
          <div class="new-incident-header">
            {{ 'addDeviceToTicket_popup_Title' | xsI18n }}
          </div>
          <div class="dialog-header-separator"></div>
          <div class="options-container">
            <mat-radio-group
              *ngIf="groups && groups.length > 0"
              class="select-type-group"
              #createNewRadio
              [(ngModel)]="createNew"
            >
              <mat-radio-button class="radio-option-create-new" [disableRipple]="true" [value]="true">
                <div>{{ 'addDeviceToTicket_popup_Option_New_Incident' | xsI18n }}</div>
              </mat-radio-button>
              <mat-radio-button class="radio-option-existing" [disableRipple]="true" [value]="false">
                <div>{{ 'addDeviceToTicket_popup_Option_Existing_Incident' | xsI18n }}</div>
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="new-incident-middle" *ngIf="createNew && !singleGroup">
            <div class="select-label">
              <span>{{ 'createTicket_selectgroup_caption' | xsI18n }}</span>
            </div>
            <div class="mat-select-holder" *ngIf="groups && groups.length > 1">
              <div class="mat-drowpdown-selector-custom">
                <mat-select
                  #groupSelector
                  class="sa-create-ticket-mat-select"
                  sa-mat-select-backdrop-click-handler
                  sa-mat-select-size-fix
                  [(value)]="selectedGroup"
                  panelClass="sa-mat-select-panel {{ opened ? 'sa-mat-select-opened' : '' }}"
                  (openedChange)="opened = $event; onDropdownOpened($event)"
                  [ngClass]="opened ? 'sa-mat-select-open' : ''"
                  disableOptionCentering
                  disableRipple
                  (selectionChange)="onSelectionChange()"
                >
                  <mat-option
                    sa-stop-propagation
                    *ngFor="let item of groups"
                    [value]="item"
                    matTooltip="{{ item.groupName }}"
                    matTooltipPosition="above"
                    placement="top"
                    (click)="onOptionClick()"
                  >
                    {{ item.groupName }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>

          <div class="new-incident-middle" *ngIf="!createNew">
            <div class="search-and-pick-label">
              <span>{{ 'addDeviceToTicket_popup_Label_Search_Incident' | xsI18n }}</span>
            </div>
            <div class="search-and-pick-holder" sa-stop-propagation>
              <xs-search-and-pick-v2
                sa-stop-propagation
                #ticketSearch
                placeholder="{{ 'standalone-attach-incident-placeholder' | xsI18n }}"
                idField="prefixedId"
                [toolDisabled]="true"
                [showSearchAndCancelIcons]="true"
                [preventClearOnSelect]="true"
                [searchResource]="ticketsResource"
                (onPick)="selectIncident($event)"
                itemTemplateName="incidentCardTemplate"
              >
              </xs-search-and-pick-v2>
            </div>
          </div>

          <div class="new-incident-footer">
            <button 
              class="xs-btn btn-outline btn-space" 
              type="button" 
              (click)="createIncidentPopoutTrigger.close();"
            >
              <span>{{ 'xs_cancel_label' | xsI18n }}</span>
            </button>
            <button 
              class="xs-btn btn-primary" 
              type="button" 
              (click)="selectTicket()" 
              [disabled]="isSaveDisabled()"
            >
              <span>{{ 'addToIncident_createTicket_Create_Button' | xsI18n }}</span>
            </button>
          </div>
        </div>
      </div>
    </xs-popup-menu>
  </soti-popup>
</div>
